import { node } from 'prop-types'
import { Provider as ReduxProvider } from 'react-redux'
import { BaseStore } from '../BaseStore'

export { BaseStore as store }

export const Provider = ({ children }) => (
  <ReduxProvider store={BaseStore}>{children}</ReduxProvider>
)

Provider.propTypes = {
  children: node,
}

export default Provider
